
import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";

// Import necessary chart.js elements
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);


interface Props {

  useranalysis:string
}


export default function UserAnalysis({useranalysis}:any) {
  // Doughnut chart data
  const data = {
    labels: ["Active", "Inactive"],
    datasets: [
      {
         data: [useranalysis.active_length, useranalysis.inactive_length],
        // data: [2, 40],
        backgroundColor: ["#78B1FD", "#FFBA90"],
        hoverBackgroundColor: ["#78B1FD", "#FFBA90"],
      },
    ],
  };
console.log(useranalysis, "useranalysisuseranalysis")
  return (
    <Box
      sx={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        p: 2,
        background: "#fff",
        width: "100%",
        marginTop: "40px",
      }}
    >
      {/* Header */}
      <Typography
        variant="h6"
        sx={{ fontWeight: "bold", fontSize: "18px", mb: 1 }}
      >
        User Analysis
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "#7D7E7F", mb: 3, fontSize: "12px" }}
      >
        Analytics of registered (onboarded) retailers on the Mitr app tracking
        their login activity.
      </Typography>

      <Grid container spacing={4}>
        {/* Doughnut Chart Section */}
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              textAlign: "center",
              position: "relative",
              width: "244px",
              marginLeft: "50px",
            }}
          >
            <Doughnut
              data={data}
              options={{
                cutout: "70%",
                plugins: {
                  legend: {
                    display: false,
                  },
                },
              }}
            />
            <Typography
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "24px",
                fontWeight: "bold",
                zIndex: 1,
                width: "200px",
              }}
            >
             {useranalysis.total_length}
            </Typography>
            <Typography
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, 30%)",
                fontSize: "14px",
                color: "#7D7E7F",
                zIndex: 1,
              }}
            >
              Total onboarded retailers
            </Typography>
          </Box>
        </Grid>

        {/* Details Section */}
        <Grid item xs={12} sm={6}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", fontSize: "24px", color: "#0076D3" }}
            >
              {useranalysis.active_length} 
            </Typography>
            <Typography sx={{ ml: 1, fontSize: "16px", color: "#000" }}>
               {useranalysis.active_percentage}
            </Typography>
            <ArrowUpward sx={{ color: "#3BA755", ml: 1 }} />
          </Box>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "#282829",
            }}
          >
            Active
          </Typography>
          <Typography sx={{ fontSize: "14px", color: "#7D7E7F", mb: 3 }}>
            User count who logged in today
          </Typography>




          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", fontSize: "24px", color: "#FF933A" }}
            >
             {useranalysis.inactive_length} 
            </Typography>
            <Typography sx={{ ml: 1, fontSize: "16px", color: "#000" }}>
            {useranalysis.inactive_percentage}
            </Typography>
            <ArrowDownward sx={{ color: "#BA0516", ml: 1 }} />
          </Box>
          <Typography
            sx={{ fontSize: "14px", fontWeight: "bold", color: "#282829" }}
          >
            Inactive
          </Typography>
          <Typography sx={{ fontSize: "14px", color: "#7D7E7F" }}>
            User count who hasn’t logged in today
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

